import { Contact } from "./Contact";
import { FileMetadata } from "./FileMetadata";
import { Organization } from "./Organization";

export enum ShipmentStatus {
  PENDING = "PENDING",
  SCHEDULED = "SCHEDULED",
  SENT = "SENT",
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  CANCELED = "CANCELED",
};

export enum ShipmentMessageType {
  TEXT = "TEXT",
  DOCUMENT = "DOCUMENT",
  IMAGE = "IMAGE",
  AUDIO = "AUDIO",
  VIDEO = "VIDEO",
  // TODO - implementar outros tipos de mensagem
  // STICKER = "STICKER",
  // LOCATION = "LOCATION",
  // CONTACT = "CONTACT",
  // REACTION = "REACTION",
};

export interface Shipment {
  id: string;
  organization: Organization;
  contact: Contact;
  content: string;
  title: string;
  url: string | null;
  fileMetadata?: FileMetadata | null;
  shipmentMessageType: ShipmentMessageType;
  status: ShipmentStatus;
  sendDate: string;
  sendTime: string | null;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
};
